import { render, staticRenderFns } from "./veJkyMeetRemind.vue?vue&type=template&id=adb30524&scoped=true"
import script from "./veJkyMeetRemind.vue?vue&type=script&lang=js"
export * from "./veJkyMeetRemind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb30524",
  null
  
)

export default component.exports